import {Fragment, useEffect} from "react";
import {Route, Routes} from "react-router-dom"
import {useIsAuthenticated} from "@azure/msal-react";
import {PublicClientApplication} from "@azure/msal-browser";
import Zendesk, {ZendeskAPI} from "./config/ZendeskConfig";

import GetAllowedRoutesFromRole from "./helpers/GetAllowedRoutesFromRole";
import PrivateRoutesConfig from "./config/PrivateRoutesConfig";
import PopulateAllowedRoutes from "./components/PopulateAllowedRoutes";
import Root from "./components/Root";
import {assignedRolesVar} from "./config/Cache";
import Loader from "./components/Loader";
import {useCurrentUser} from "./hooks/useCurrentUser";
import useGainedFocus from "./hooks/useGainedFocus";
import {authConfig, vegasTokenScopes} from "./authConfig";

const REACT_APP_ZENDESK_KEY = "f3b3d81f-5bf4-4395-b9aa-7d6ce824c677";

export default function App() {

  const {loading} = useCurrentUser();

  const isAuthenticated = useIsAuthenticated();
  const hasGainedFocusAfterBeingUnfocused = useGainedFocus();
  const securityClient = new PublicClientApplication(authConfig);

  useEffect(() => {
    const refreshTokenSilently = async () => {
      try {
        await securityClient.initialize();
        const account = securityClient.getAllAccounts()[0];

        if (account && hasGainedFocusAfterBeingUnfocused) {
          console.log("App has been unfocused for a long time. Refreshing token...");
          await securityClient.acquireTokenSilent({
            account,
            ...vegasTokenScopes,
          });
          console.log("Token refreshed successfully for app.");
        }
      } catch (error) {
        console.error("Failed to refresh token for the app:", error);
      }
    };

    refreshTokenSilently();
  }, [hasGainedFocusAfterBeingUnfocused]);

  if (loading) {
    return <Loader/>;
  }

  let allowedRoutesList = [];

  if (isAuthenticated) {

    const roles = assignedRolesVar();

    allowedRoutesList = GetAllowedRoutesFromRole(PrivateRoutesConfig, roles);
  }

  const handleZendeskLoaded = () => {
    try {
      ZendeskAPI("messenger", "hide");
    } catch (error) {
      console.error("Zendesk API call failed:", error);
    }
  };

  return (
    <>
      { <Zendesk defer zendeskKey={REACT_APP_ZENDESK_KEY} onLoaded={handleZendeskLoaded} />}

      {isAuthenticated
          && <Fragment>
          <PopulateAllowedRoutes routes={allowedRoutesList} />
        </Fragment>
      }
      {
        !isAuthenticated
          && <Routes>
          <Route path="*" element={<Root />} />
        </Routes>
      }
    </>
  )
}
